export default
{
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
    TOP: 'top',
    BOTTOM: 'bottom'
}



// WEBPACK FOOTER //
// ./src/scripts/constants/menu-layouts.js